// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__9Zr-B","tabs_controls":"Tabs_tabs_controls__5IJ0B","tabs_control":"Tabs_tabs_control__wzl98","tabs_active":"Tabs_tabs_active__CXnEK"};